export function isBrowser(): boolean {
  return process.env.TARGET === 'browser';
}
